import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Product } from 'src/app/openapi/api';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-products-favorites-list',
  templateUrl: './products-favorites-list.component.html',
  styleUrls: ['./products-favorites-list.component.scss']
})
export class ProductsFavoritesListComponent extends BaseComponent implements OnInit {
  @Input()
  favorites: Product[];

  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
  }
}
